import { render, staticRenderFns } from "./SpotWidgetCounterControl.global.vue?vue&type=template&id=20f53272&lang=pug&"
import script from "./SpotWidgetCounterControl.global.vue?vue&type=script&lang=ts&"
export * from "./SpotWidgetCounterControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports